<template>
    <div class="pr">
        <template v-if="isEdit">
            <uinput v-model="currentValue" :isSmall="true" :width="80" style="margin: -10px 10px;"></uinput>
            <el-link @click="save">{{$t('save')}}</el-link>
            <span class="pa red" v-if="err" :class="$style.error">{{err}}</span>
        </template>
        <template v-else>
            <span>{{displayValue}}</span>
            <img src="../assets/edit.png" alt="" style="width: 26px; height:26px;vertical-align: -5px;margin-left:10px;" class="cp" @click="isEdit = true">
        </template>
    </div>
</template>
<script>
export default {
    name: 'Edit',
    props: {
        propName: {type: String, defualt: ''},
        value: {type: String, defualt: ''},
    },
    data() {
        return {
            isEdit: false,
            currentValue: '',
            err: '',
        };
    },
    computed: {
        displayValue() {
            return this.value;
        },
    },
    methods: {
        save() {
            const params = {};
            params[this.propName] = this.currentValue;
            this.$emit('change', {params, cb: this.cb});
        },
        cb(err) {
            if (err) {
                this.err = err;
            } else {
                this.isEdit = false;
            }
        }
    }

}
</script>
<style module>
.error {
    font-size: 14px;left: 26px;top: 44px;
}
@media screen and (max-width: 770px) {
    .error {
        top: 20px;
    }
}
</style>
